import { useState, useEffect, useCallback } from 'react';
import API from '../common/api.js';

const useLeadsHandledByAttorney = ({ attorneyUserId }) => {
    const [leads, setLeads] = useState(null);
    const [loading, setLoading] = useState(true);
    const [errorMessage, setErrorMessage] = useState(null);
    const [initialized, setInitialized] = useState(false);

    const loadData = useCallback(async () => {
        if (!attorneyUserId) {
            setLeads([]);
            setInitialized(true);
            setLoading(false);
            return;
        }

        setLoading(true);
        setErrorMessage(null);

        const response = await API.getLeadsHandledByAttorney(attorneyUserId);

        if (response) {
            setLeads(response.leads || response);
            setInitialized(true);
        } else {
            setErrorMessage(
                'Failed to load the leads for this Attorney. Please try again or report this problem, if it persists.'
            );
        }

        setLoading(false);
    }, [attorneyUserId]);

    useEffect(() => {
        loadData();
    }, [loadData]);

    return {
        leads,
        loading,
        errorMessage,
        initialized,
        reload: loadData,
    };
};

export default useLeadsHandledByAttorney;
